import { render, staticRenderFns } from "./MidwifePropertyOverview.vue?vue&type=template&id=5db7d822"
import script from "./MidwifePropertyOverview.vue?vue&type=script&lang=js"
export * from "./MidwifePropertyOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports